/** @format */

import {
  Button,
  Loading,
  Modal,
  TextInput,
  Tile,
} from "carbon-components-react";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import UIShell from "../../components/UIShell";
import UIShellPagination from "../../components/UIShellPagination";
import PageHelper from "../../helpers/Pagehelper";
import {
  fetchAllSkills,
  bulkDeleteSkill,
  updateSkill,
} from "../../redux/actions/skillAction";

function SkillsPage({ isLoading }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [isLoadingData, setIsLoadingData] = useState(true);

  const headers = [
    {
      key: "skillName",
      header: "Skill name",
    },
  ];

  const [paginationContent, setPaginationContent] = useState({
    query: "",
    page: 0,
    limit: 20,
    total: 0,
    totalItems: 0,
    rows: [],
  });

  const [modalContent, setModalContent] = useState({
    modalHeading: "",
    isOpen: false,
    skillId: undefined,
    skillName: undefined,
  });

  const mapToColumn = (row) => {
    return {
      _id: row._id,
      skillName: row.name,
    };
  };

  const updateSkillDetail = () => {
    dispatch(
      updateSkill(
        {
          skillId: modalContent.skillId,
          skillName: modalContent.skillName,
        },
        () => {
          // reset modal content
          setModalContent({
            modalHeading: "",
            isOpen: false,
            skillId: undefined,
            skillName: undefined,
          });

          fetch({ query: "", page: 0, limit: paginationContent.limit });
        }
      )
    );
  };

  const bulkDelete = async (_items) => {
    dispatch(
      bulkDeleteSkill(
        {
          skillIds: _items.map((v) => ({
            _id: v.id,
          })),
        },
        () => {
          fetch({ query: "", page: 0, limit: paginationContent.limit });
        }
      )
    );
  };

  const viewSkillDetail = (_data) => {
    const skillId = _data[0].id.split(":")[0];
    const skillName = _data.filter((v) => v.info.header === "skillName")[0]
      ?.value;

    setModalContent((v) => ({
      isOpen: true,
      modalHeading: `${skillName}`,
      skillId,
      skillName,
    }));
  };

  const paginationChange = async (_newPage) => {
    fetch({
      query: paginationContent.query,
      page: _newPage,
      limit: paginationContent.limit,
    });
  };

  const searchTable = async (e) => {
    const { value } = e.target;

    fetch({
      query: value,
      page: 0,
      limit: paginationContent.limit,
    });
  };

  const fetch = ({ query, page, limit }) => {
    setIsLoadingData(true);
    dispatch(
      fetchAllSkills(
        { query, page, limit },
        ({ filteredData, totalFiltered, total }) => {
          setPaginationContent((v) => ({
            ...v,
            skip: totalFiltered,
            query,
            limit,
            page,
            total,
            totalItems: PageHelper.getTotalItems(total, limit),
            rows: filteredData.map(mapToColumn),
          }));
          setIsLoadingData(false);
        }
      )
    );
  };

  useEffect(() => {
    fetch(paginationContent);
  }, []);

  return (
    <UIShell breadcrumbs={[{ name: "Home", link: "/" }, { name: "Skills" }]}>
      {isLoadingData && <Loading />}
      <UIShellPagination
        dataTableList={paginationContent.rows}
        headers={headers}
        searchTable={searchTable}
        bulkDelete={bulkDelete}
        createForm={() => history.push("/skills/form")}
        viewDetail={viewSkillDetail}
        paginationChange={paginationChange}
        totalItems={paginationContent.totalItems}
        page={paginationContent.page}
        withExpander={true}
      />

      <Modal
        modalHeading={modalContent.modalHeading}
        modalLabel="Skill details"
        primaryButtonText="Update"
        primaryButtonDisabled={isLoading}
        secondaryButtonText="Cancel"
        open={modalContent.isOpen}
        onRequestSubmit={() => updateSkillDetail()}
        onRequestClose={() => setModalContent((v) => ({ ...v, isOpen: false }))}
      >
        <TextInput
          data-modal-primary-focus
          labelText="Skill Name"
          placeholder="skill name"
          value={modalContent.skillName}
          onChange={(_v) =>
            setModalContent((v) => ({ ...v, skillName: _v.target.value }))
          }
          style={{ marginBottom: "1rem" }}
        />
      </Modal>
    </UIShell>
  );
}

const mapStateToProps = (state) => {
  return {
    dataTableList: state.skillReducer.dataTableList,
    isLoading: state.uxReducer.isLoading,
  };
};

export default connect(mapStateToProps)(SkillsPage);
